<template>
    <o-modal @showModalDuration="showModalDuration" @close="closeModalDuration" modalClass="inject-modal-wide">
        <template v-slot:header>
            {{ item.title }}
        </template>
        <template v-slot:body>
            <o-form autocomplete="off">

                <o-form-group title="" name="state">
                    <!-- Two-column container -->
                    <div class="two-col-layout">
                        <div class="left-panel">
                            <p class="panel-title">Select Member</p>
                            <template v-if="item.member_id && item.title == 'Edit Member Inject Point'">
                                <o-input-text name="member_name" v-model="item.member_name" disabled />
                            </template>
                            <template v-else>
                                <div class="member-search-row">
                                    <div class="member-search-wrap">
                                        <i class="fas fa-search search-icon"></i>
                                        <input type="text" class="member-search-input" v-model="memberSearch"
                                            placeholder="Search by name or email" />
                                        <button v-if="memberSearch" class="search-clear-btn" @click="clearMemberSearch"
                                            type="button">&times;</button>
                                    </div>
                                    <button type="button" class="btn-scan" data-bs-toggle="modal"
                                        data-bs-target="#scanner-modal-inject" @click="startScan" title="Scan QR Code">
                                        <i class="fas fa-qrcode"></i>
                                    </button>
                                </div>

                                <!-- Member list -->
                                <div class="member-list-scroll" ref="membersListRef" @scroll="handleMemberScroll">
                                    <div v-if="!membersLoaded" class="member-list-empty">
                                        <i class="fas fa-spinner fa-spin"></i> Loading members...
                                    </div>
                                    <div v-else-if="displayMembers.length === 0" class="member-list-empty">
                                        No members found
                                    </div>
                                    <div v-else v-for="member in orderedDisplayMembers" :key="member.id"
                                        class="member-card" :class="{ selected: item.member_id === member.id }"
                                        @click="selectMember(member)">
                                        <div class="member-card-content">
                                            <div class="member-avatar">
                                                <img v-if="member.photo && !member.imageError" :src="member.photo"
                                                    :alt="member.full_name" class="avatar-img"
                                                    @error="member.imageError = true" />
                                                <span v-else class="avatar-initials">{{ getInitials(member.full_name)
                                                    }}</span>
                                            </div>
                                            <div class="member-info">
                                                <p class="member-name">{{ member.full_name }}</p>
                                                <p class="member-email">{{ member.email }}</p>
                                                <p class="member-code">{{ member.code }}</p>
                                            </div>
                                        </div>
                                        <div class="member-check-wrap">
                                            <div v-if="item.member_id === member.id" class="member-check">
                                                <i class="fas fa-check"></i>
                                            </div>
                                            <div v-else class="member-radio"></div>
                                        </div>
                                    </div>
                                    <div v-if="loadingMore" class="member-list-empty">
                                        <i class="fas fa-spinner fa-spin"></i> Loading members...
                                    </div>
                                </div>
                            </template>
                        </div>

                        <!-- ===== RIGHT PANEL: Form Fields ===== -->
                        <div class="right-panel">
                            <!-- Manipulation Type -->
                            <div class="form-section">
                                <p class="panel-title">Manipulation Type</p>
                                <template v-if="isEditMode">
                                    <o-input-text v-model="statusText" :disabled="isEditMode" label="Status" />
                                </template>
                                <template v-else>
                                    <div class="type-cards">
                                        <div class="type-card" :class="{ active: item.status === 'add' }"
                                            @click="item.status = 'add'">
                                            <div class="type-card-check">
                                                <div v-if="item.status === 'add'" class="type-card-check-filled"><i
                                                        class="fas fa-check"></i></div>
                                                <div v-else class="type-card-check-empty"></div>
                                            </div>
                                            <img src="https://s3.ap-southeast-1.amazonaws.com/cdn-member.omnihotelier.com/public/img/topup_icon.svg"
                                                class="type-card-icon" alt="Top Up">
                                            <span class="type-card-label">Top Up Point</span>
                                        </div>
                                        <div class="type-card" :class="{ active: item.status === 'remove' }"
                                            @click="item.status = 'remove'">
                                            <div class="type-card-check">
                                                <div v-if="item.status === 'remove'" class="type-card-check-filled"><i
                                                        class="fas fa-check"></i></div>
                                                <div v-else class="type-card-check-empty"></div>
                                            </div>
                                            <img src="https://s3.ap-southeast-1.amazonaws.com/cdn-member.omnihotelier.com/public/img/deduct_icon.svg"
                                                class="type-card-icon" alt="Deduct">
                                            <span class="type-card-label">Deduct Point</span>
                                        </div>
                                    </div>
                                </template>
                            </div>

                            <!-- Calculation Method -->
                            <div v-if="item.status === 'add' && hasPointPlan && !isEditMode && allowGenerateCalculate"
                                class="form-section">
                                <p class="panel-title">Calculation Method</p>
                                <div class="radio-group">
                                    <label class="radio-option"
                                        :class="{ active: item.calculateMethod === 'generate' }">
                                        <input type="radio" id="generate" value="generate"
                                            v-model="item.calculateMethod" />
                                        <span class="radio-check"></span>
                                        <span class="radio-label">By Amount</span>
                                    </label>
                                    <label class="radio-option" :class="{ active: item.calculateMethod === 'manual' }">
                                        <input type="radio" id="manual" value="manual" v-model="item.calculateMethod" />
                                        <span class="radio-check"></span>
                                        <span class="radio-label">By Point</span>
                                    </label>
                                </div>
                            </div>

                            <!-- Generate Calculate Value -->
                            <div v-if="item.calculateMethod === 'generate' && !isEditMode" class="form-section">
                                <div class="custom-input-card">
                                    <div class="input-icon-wrap">
                                        <i class="fas fa-money-bill-wave"></i>
                                    </div>
                                    <input type="text" class="custom-input-field" name="generate_calculate"
                                        v-model="formattedGenerateCalculate" placeholder="Enter calculate value..."
                                        required @keydown="preventInvalidCalcInput" @paste="handleCalcPaste" />
                                </div>
                            </div>

                            <!-- Point -->
                            <div class="form-section">
                                <div class="custom-input-card"
                                    :class="{ 'is-disabled': item.calculateMethod === 'generate' || isEditMode }">
                                    <div class="input-icon-wrap">
                                        <i class="fas fa-coins"></i>
                                    </div>
                                    <input type="text" class="custom-input-field" name="point"
                                        :value="item.point !== null && item.point !== '' ? Number(item.point).toLocaleString('id-ID') : ''"
                                        @input="validatePointInput" @keydown="preventInvalidPointInput"
                                        @paste="handlePointPaste" required
                                        :disabled="item.calculateMethod === 'generate' || isEditMode" placeholder="0" />
                                </div>
                            </div>

                            <div class="form-section">
                                <p class="panel-title">Note (Required)</p>
                                <textarea class="form-textarea" v-model="item.description" rows="4"
                                    placeholder="Write a clean note..."></textarea>
                            </div>
                        </div>
                    </div>

                    <!-- Footer — outside two-col-layout, matching Figma -->
                    <div class="form-footer">
                        <!-- Error Alert inside Footer -->
                        <div v-if="errors.length" class="error-alert-footer">
                            <i class="fas fa-exclamation-circle error-alert-icon"></i>
                            <div>
                                <p class="error-alert-title">Please correct the following error(s):</p>
                                <ul class="error-list">
                                    <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
                                </ul>
                            </div>
                        </div>
                        <div class="footer-actions">
                            <button type="button" class="btn-cancel" @click="closeModalDuration">Cancel</button>
                            <button type="button" class="btn-confirm" @click="saveDetailDuration" :disabled="isSaving">
                                <i v-if="isSaving" class="fas fa-spinner fa-spin"></i>
                                {{ isSaving ? 'Saving...' : 'Confirm' }}
                            </button>
                        </div>
                    </div>
                </o-form-group>
            </o-form>
        </template>
    </o-modal>

    <!-- Scanner Modal — teleported to body, z-index above OModal (9999) -->
    <teleport to="body">
        <div v-if="!scanHidden" class="scan-overlay" @click.self="stopScan">
            <div class="scan-modal-box">
                <div class="scan-modal-header">
                    <span class="scan-modal-title">Scanning</span>
                    <button type="button" class="scan-modal-close" @click="stopScan" aria-label="Close">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
                <div class="scan-modal-body">
                    <div id="wrap-scanner-inject"></div>
                    <div class="scan-message" v-if="error_scan.message != ''">{{ error_scan.message }}</div>
                </div>
                <div class="scan-modal-footer">
                    <button type="button" class="btn-stop-scan" @click="stopScan">Stop scanning</button>
                </div>
            </div>
        </div>
    </teleport>

</template>

<script>
    import { OModal, OForm, OFormGroup, OInputText } from '@/components/OmnihControl';
    import { Html5Qrcode } from 'html5-qrcode';
    import { mapState } from 'vuex';
    import store from '@/store/';

    export default {
        name: 'AddDetailDuration',
        components: {
            OModal,
            OForm,
            OFormGroup,
            OInputText,
        },
        props: [
            'editedItemDuration',
            'validationdetail',
            'members',
            'pointplans',
            'allowGenerateCalculate'
        ],
        data() {
            return {
                item: {
                    title: 'Member Inject Point',
                    status: '',
                    member_id: '',
                    member_name: '',
                    code: '',
                    description: '',
                    data: [],
                    generate_calculate: '',
                    point: null,
                    calculateMethod: 'generate',
                },
                rawGenerateCalculate: '',
                validationDetail: this.validationdetail,
                isModalVisibleDuration: false,
                errors: [],
                isEditMode: false,
                statusOptions: [
                    { value: 'add', text: 'Top Up Point' },
                    { value: 'remove', text: 'Deduction Point' },
                ],
                isSaving: false,
                // Member search & scan state
                memberSearch: '',
                membersLoaded: false,
                displayMembers: [],
                selectedMemberObj: null,
                selectedViaSearch: false,
                loadingMore: false,
                scanHidden: true,
                error_scan: { message: '' },
                scanner: null,
                cameraId: '',
                corporateId: '',
                searchDebounceTimer: null,
                preloadAbort: false,
            }
        },
        mounted() {
            if (Object.keys(this.editedItemDuration).length !== 0) {
                this.item = { ...this.editedItemDuration };
                this.item.title = 'Edit Member Inject Point';
                this.isEditMode = true;
                this.item.calculateMethod = this.item.calculateMethod || 'generate';
            } else if (!this.allowGenerateCalculate) {
                this.item.calculateMethod = 'manual';
            }
            Html5Qrcode.getCameras().then(devices => {
                if (devices && devices.length) this.cameraId = devices[0].id;
            }).catch(err => console.error('getCameras error', err));
            this.loadMemberInit();
        },
        beforeUnmount() {
            try {
                if (this.scanner && this.scanner.clear) this.scanner.clear();
            } catch (e) {
                console.error('Failed to clear scanner on unmount', e);
            }
            if (this.searchDebounceTimer) clearTimeout(this.searchDebounceTimer);
        },
        methods: {
            handleSelectedMember(memberId) {
                this.item.member_id = memberId;
            },
            getInitials(name) {
                if (!name) return '?';
                return name.split(' ').slice(0, 2).map(n => n[0]).join('').toUpperCase();
            },
            mapMember(m) {
                return {
                    ...m,
                    full_name: `${m.title || ''} ${m.first_name || ''} ${m.last_name || ''}`.trim(),
                    email: m.user?.email || '',
                    code: m.code || '',
                    photo: m.photo || m.user?.user_profile?.avatar?.image_url || null,
                    imageError: false,
                };
            },
            selectMember(member) {
                this.item.member_id = member.id;
                this.item.member_name = member.full_name;
                this.selectedMemberObj = { ...member };
                // Only pin to top if member was picked while search is active
                this.selectedViaSearch = !!(this.memberSearch && this.memberSearch.trim());
            },
            async loadMemberInit() {
                this.membersLoaded = false;
                this.displayMembers = [];
                // Set limit synchronously BEFORE any await — prevents store default (20) from firing first
                store.commit('Member/reset_meta');
                store.commit('Member/switch_page', { meta: { page: 1, limit: 10 } });
                try {
                    const bp = await store.dispatch('Auth/getBusinessProfile');
                    this.corporateId = bp.corporate_id;
                    store.commit('Member/add_filter', { filter: { corporate_id: this.corporateId } });
                    await store.dispatch('Member/read');
                    this.displayMembers = (store.state.Member.members || []).map(this.mapMember);
                    this.membersLoaded = true;
                } catch (e) {
                    console.error('Failed to load members', e);
                    this.membersLoaded = true;
                }
            },
            async clearMemberSearch() {
                this.memberSearch = '';
                store.commit('Member/clear_search');
                await this.loadMemberInit();
            },
            async handleMemberScroll() {
                const el = this.$refs.membersListRef;
                if (!el || this.loadingMore) return;

                // Prevent triggering infinite scroll if user is currently using local search
                if (this.memberSearch && this.memberSearch.trim() !== '') return;

                const distanceToBottom = el.scrollHeight - el.scrollTop - el.clientHeight;
                if (distanceToBottom < 100) {
                    const meta = store.state.Member.meta || {};

                    // Explicitly cast to Number to avoid string concatenation bugs (e.g. "1" + 1 = "11")
                    const currentPage = Number(meta.page) || 1;
                    const limit = Number(meta.limit) || 20;
                    // The backend API already calculates total pages and returns it as `meta.total`
                    const totalPages = Number(meta.total) || 0;

                    if (currentPage < totalPages) {
                        this.loadingMore = true;
                        const nextMeta = { ...meta, page: currentPage + 1, limit: limit };
                        store.commit('Member/switch_page', { meta: nextMeta });
                        try {
                            await store.dispatch('Member/read');
                            const newMembers = (store.state.Member.members || []).map(this.mapMember);
                            this.displayMembers = [...this.displayMembers, ...newMembers];
                        } catch (e) {
                            console.error('Failed to load more members', e);
                        } finally {
                            this.loadingMore = false;
                        }
                    }
                }
            },
            startScan() {
                this.scanHidden = false;
                this.$nextTick(() => {
                    if (!this.cameraId) return;
                    this.scanner = new Html5Qrcode('wrap-scanner-inject');
                    const config = { fps: 4, qrbox: { width: '100%', height: '100%' } };
                    this.scanner.start(
                        { deviceId: { exact: this.cameraId } },
                        config,
                        this.onScanSuccess
                    ).catch(err => console.error('scanner.start failed', err));
                });
            },
            stopScan() {
                try {
                    if (this.scanner && this.scanner.stop) this.scanner.stop();
                } catch (e) {
                    console.error('Failed to stop scanner', e);
                }
                this.preloadAbort = true;
                this.scanHidden = true;
            },
            async onScanSuccess(decodedText) {
                let memberData;
                try {
                    memberData = JSON.parse(decodedText);
                } catch (e) {
                    this.error_scan.message = 'Invalid QR data';
                    setTimeout(() => { this.error_scan.message = ''; }, 1000);
                    return;
                }
                const found = (store.state.Member.members || []).find(m => String(m.id) === String(memberData.memberId));
                if (found) {
                    // Only show the scanned member in the list
                    this.displayMembers = [this.mapMember(found)];
                    this.selectMember(this.mapMember(found));
                    this.stopScan();
                    return;
                }
                try {
                    const res = await store.dispatch('Member/read_single', memberData.memberId);
                    if (res) {
                        store.commit('Member/add_single_member', { member: res });
                        // Only show the scanned member in the list
                        this.displayMembers = [this.mapMember(res)];
                        this.selectMember(this.mapMember(res));
                        this.stopScan();
                        return;
                    }
                    this.error_scan.message = 'Member not found';
                    setTimeout(() => { this.error_scan.message = ''; }, 1000);
                } catch (err) {
                    console.error('read_single failed', err);
                    this.error_scan.message = 'Member not found';
                    setTimeout(() => { this.error_scan.message = ''; }, 1000);
                }
            },
            showModalDuration() {
                this.isModalVisibleDuration = true;
            },
            closeModalDuration(e) {
                if (e && e.preventDefault) {
                    e.preventDefault();
                }
                this.$emit('parentCloseModal');
            },
            saveDetailDuration() {
                if (this.isSaving) {
                    return;
                }
                this.errors = [];

                if (!this.item.member_id) {
                    this.errors.push('Member is required.');
                }

                if (!this.isEditMode) {
                    const MAX_POINT = 1000000;
                    if (this.item.point === null || this.item.point === "" || this.item.point == undefined) {
                        this.errors.push('Point is required.');
                    } else if (this.item.point <= 0 || this.item.point.toString().includes('-')) {
                        this.errors.push('Point must be greater than 0.');
                    } else if (Number(this.item.point) > MAX_POINT) {
                        this.errors.push('The point value you entered exceeds the maximum allowed. Please enter a smaller value (max 1,000,000).');
                    }

                    if (this.item.calculateMethod === 'generate') {
                        const MAX_CALC = 900000000;
                        const rawCalc = (this.rawGenerateCalculate || '').replace(/[^0-9]/g, '');
                        if (rawCalc && parseInt(rawCalc) > MAX_CALC) {
                            this.errors.push('The calculate value you entered exceeds the maximum allowed. Please enter a smaller value (max 900,000,000).');
                        }
                    }
                }

                if (!this.item.status) {
                    this.errors.push('Status is required.');
                }

                if (!this.item.description) {
                    this.errors.push('Notes is required.');
                }

                if (this.errors.length === 0) {
                    this.isSaving = true;

                    this.$emit('parentAddItem', this.item);
                    this.isModalVisibleDuration = false;
                }
            },
            formatPrice(value) {
                if (value === null || value === undefined || value === '') return '';
                const number = Number(value.toString().replace(/[^0-9]/g, ""));
                if (isNaN(number)) return '';
                return 'Rp. ' + number.toLocaleString('id-ID');
            },
            // ── Calculate Value input guards (mirrors TransactionDetail price pattern) ──
            preventInvalidCalcInput(event) {
                const MAX_CALC = 900000000;
                const key = event.key;
                const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
                if (allowedKeys.includes(key)) return true;
                if (event.ctrlKey || event.metaKey) return true;
                if (!/^[0-9]$/.test(key)) {
                    event.preventDefault();
                    return false;
                }
                // Block if appending this digit would exceed MAX
                const currentRaw = (this.rawGenerateCalculate || '').replace(/[^0-9]/g, '');
                const projected = parseInt(currentRaw + key) || 0;
                if (projected > MAX_CALC) {
                    event.preventDefault();
                    return false;
                }
                return true;
            },
            handleCalcPaste(event) {
                event.preventDefault();
                const MAX_CALC = 900000000;
                const pastedData = (event.clipboardData || window.clipboardData).getData('text');
                let numericValue = pastedData.replace(/[^0-9]/g, '');
                if (numericValue.length > 9) numericValue = numericValue.substring(0, 9);
                let num = parseInt(numericValue) || 0;
                if (num > MAX_CALC) num = MAX_CALC;
                // Trigger through computed setter
                this.formattedGenerateCalculate = num.toString();
            },
            // ── Point input guards ──
            validatePointInput(event) {
                const MAX_POINT = 1000000;
                let inputValue = event.target.value;
                let numericValue = inputValue.replace(/[^0-9]/g, '');
                if (numericValue.length > 9) numericValue = numericValue.substring(0, 9);
                let num = parseInt(numericValue) || 0;
                if (num > MAX_POINT) num = MAX_POINT;
                this.item.point = num === 0 ? null : num;
                // Reflect cleaned value back to input with separator
                event.target.value = num === 0 ? '' : num.toLocaleString('id-ID');
            },
            preventInvalidPointInput(event) {
                const MAX_POINT = 1000000;
                const key = event.key;
                const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
                if (allowedKeys.includes(key)) return true;
                if (event.ctrlKey || event.metaKey) return true;
                if (!/^[0-9]$/.test(key)) {
                    event.preventDefault();
                    return false;
                }
                // Block if appending this digit would exceed MAX
                const currentStr = this.item.point !== null ? this.item.point.toString() : '';
                const projected = parseInt(currentStr + key) || 0;
                if (projected > MAX_POINT) {
                    event.preventDefault();
                    return false;
                }
                return true;
            },
            handlePointPaste(event) {
                event.preventDefault();
                const MAX_POINT = 1000000;
                const pastedData = (event.clipboardData || window.clipboardData).getData('text');
                let numericValue = pastedData.replace(/[^0-9]/g, '');
                if (numericValue.length > 9) numericValue = numericValue.substring(0, 9);
                let num = parseInt(numericValue) || 0;
                if (num > MAX_POINT) num = MAX_POINT;
                this.item.point = num === 0 ? null : num;
                event.target.value = num === 0 ? '' : num.toLocaleString('id-ID');
            },
        },
        computed: {
            ...mapState({

            }),
            orderedDisplayMembers() {
                // Pin to top only AFTER search is cleared, not while search is still active
                // → during search: no reorder (no scroll jump)
                // → after clear search: reload triggers page 1 list, pin selected to top
                // → normal scroll (no search): no reorder (preserves scroll position)
                if (!this.selectedMemberObj || !this.selectedViaSearch || this.memberSearch) return this.displayMembers;
                const rest = this.displayMembers.filter(m => m.id !== this.selectedMemberObj.id);
                return [this.selectedMemberObj, ...rest];
            },
            statusText: {
                get() {
                    return this.item.status === 'add' ? 'Top Up Point' : 'Deduction Point';
                },
                set(value) {
                    if (value === 'Top Up Point') {
                        this.item.status = 'add';
                    } else if (value === 'Deduction Point') {
                        this.item.status = 'remove';
                    }
                }
            },
            hasPointPlan() {
                return this.pointplans && this.pointplans.length > 0 && !isNaN(parseFloat(this.pointplans[0].price));
            },
            formattedGenerateCalculate: {
                get() {
                    return this.item.generate_calculate;
                },
                set(value) {
                    this.rawGenerateCalculate = value;

                    let angkaStr = value.toString().replace(/[^0-9]/g, '');

                    let num = parseInt(angkaStr, 10);
                    if (isNaN(num)) {
                        this.item.generate_calculate = '';
                        this.item.point = null;
                    } else {
                        this.item.generate_calculate = this.formatPrice(num);

                        if (this.hasPointPlan) {
                            const price = parseFloat(this.pointplans[0].price);
                            const pointReward = parseFloat(this.pointplans[0].point);
                            this.item.point = Math.floor(num / price) * pointReward;
                        } else {
                            this.item.point = null;
                        }
                    }
                }
            },
        },
        watch: {
            'item.point'() {
                if (this.item.status === 'add' && !this.hasPointPlan) {
                    this.item.generate_calculate = '';
                }
            },
            'item.data.voucher_redeem_id': {
                handler(newVal) {
                    if (newVal) {
                        this.item.status = 'remove';
                    } else {
                        this.item.status = 'add';
                    }
                },
                immediate: true
            },
            'item.status'(newStatus) {
                if (newStatus === 'remove') {
                    this.item.calculateMethod = 'manual';
                } else if (newStatus === 'add') {
                    this.item.calculateMethod = this.allowGenerateCalculate ? 'generate' : 'manual';
                }
            },
            'item.calculateMethod'() {
                // guard edit mode — watcher fires on mount when status initialises
                // the method, which would wipe the existing point/generate_calculate loaded
                // from the record being edited.
                if (this.isEditMode) return;
                // Clear completely when switching method — no connection between manual and auto
                this.item.generate_calculate = '';
                this.rawGenerateCalculate = '';
                this.item.point = null;
            },
            memberSearch(val) {
                if (this.searchDebounceTimer) clearTimeout(this.searchDebounceTimer);
                this.searchDebounceTimer = setTimeout(async () => {
                    const query = (val || '').trim();
                    if (query === '') {
                        store.commit('Member/clear_search');
                        await this.loadMemberInit();
                        return;
                    }
                    try {
                        this.membersLoaded = false;
                        this.displayMembers = [];
                        await store.dispatch('Member/all', this.corporateId);
                        const all = store.state.Member.members || [];
                        const q = query.toLowerCase();
                        this.displayMembers = all
                            .filter(m => {
                                const name = `${m.title || ''} ${m.first_name || ''} ${m.last_name || ''}`.toLowerCase();
                                const email = (m.user?.email || '').toLowerCase();
                                return name.includes(q) || email.includes(q);
                            })
                            .map(this.mapMember);
                        this.membersLoaded = true;
                    } catch (e) {
                        console.error('member search failed', e);
                        await this.loadMemberInit();
                    }
                }, 350);
            }
        }
    }
</script>

<style>
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

    /* =============================================
   Scan Overlay — matches OLookupMember modal design
   z-index 10000 to appear above OModal (z-index: 9999)
============================================= */
    .scan-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10000;
        padding: 20px;
    }

    .scan-modal-box {
        background: #fff;
        border-radius: 12px;
        width: 100%;
        max-width: 500px;
        display: flex;
        flex-direction: column;
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
        animation: scan-modal-appear 0.3s ease-out;
        overflow: hidden;
    }

    @keyframes scan-modal-appear {
        from {
            opacity: 0;
            transform: translateY(20px);
        }

        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .scan-modal-header {
        padding: 20px 24px;
        border-bottom: 1px solid #f1f5f9;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .scan-modal-title {
        font-family: 'Inter', sans-serif;
        font-size: 1.125rem;
        font-weight: 600;
        color: #1e293b;
    }

    .scan-modal-close {
        background: transparent;
        border: none;
        color: #94a3b8;
        font-size: 1.25rem;
        cursor: pointer;
        padding: 4px;
        line-height: 1;
        transition: color 0.2s;
    }

    .scan-modal-close:hover {
        color: #ef4444;
    }

    .scan-modal-body {
        padding: 24px;
        flex: 1;
    }

    #wrap-scanner-inject {
        width: 100%;
        min-height: 300px;
    }

    .scan-message {
        margin-top: 10px;
        padding: 8px 12px;
        background: #fff5f5;
        border: 1px solid #fecaca;
        border-radius: 6px;
        color: #dc2626;
        font-size: 13px;
        text-align: center;
    }

    .scan-modal-footer {
        padding: 16px 24px;
        border-top: 1px solid #f1f5f9;
        display: flex;
        justify-content: center;
    }

    .btn-stop-scan {
        padding: 8px 24px;
        background: var(--secondary-color, #FEE9E9);
        color: var(--primary-color, #F27178);
        border: 1px solid var(--secondary-color, #FEE9E9);
        border-radius: 8px;
        font-family: 'Inter', sans-serif;
        font-weight: 600;
        font-size: 14px;
        cursor: pointer;
        transition: filter 0.15s;
    }

    .btn-stop-scan:hover {
        filter: brightness(0.9);
    }


    /* Wide Modal Override*/
    .inject-modal-wide {
        max-width: 872px !important;
        width: 95vw !important;
        font-family: 'Inter', sans-serif;
        max-height: 90vh !important;
        display: flex !important;
        flex-direction: column !important;
    }

    .inject-modal-wide .modal-content {
        display: flex;
        flex-direction: column;
        max-height: 90vh;
        overflow: hidden;
    }

    .inject-modal-wide .modal-body {
        overflow-y: auto;
        flex: 1;
        min-height: 0;
        padding: 20px 24px;
    }

    .inject-modal-wide .modal-footer {
        flex-shrink: 0;
    }

    /* Two Column Layout */
    .two-col-layout {
        display: flex;
        flex-direction: row;
        align-items: stretch;
        gap: 0;
        border: 1px solid #D9D9D9;
        border-radius: 12px;
        overflow: hidden;
        min-height: 460px;
    }

    .two-col-layout * {
        box-sizing: border-box;
    }

    /* Left panel */
    .left-panel {
        width: 400px;
        flex-shrink: 0;
        background: #F9F9F9;
        border-radius: 12px 0 0 12px;
        padding: 24px;
        display: flex;
        flex-direction: column;
        gap: 14px;
        overflow-y: auto;
        max-height: 100%;
    }

    /* Right panel*/
    .right-panel {
        flex: 1;
        background: #FFFFFF;
        border-radius: 0 12px 12px 0;
        padding: 24px;
        display: flex;
        flex-direction: column;
        gap: 12px;
        overflow-y: auto;
        max-height: 100%;
    }

    /* Panel label */
    .panel-title {
        font-family: 'Inter', sans-serif;
        font-weight: 700;
        font-size: 14px;
        line-height: 20px;
        color: #404040;
        margin: 0 0 8px 0;
        margin-bottom: 0px !important;
    }

    /* Error Alert*/
    .error-alert {
        display: flex;
        gap: 10px;
        background: #fff5f5;
        border: 1px solid #fecaca;
        border-radius: 8px;
        padding: 12px 14px;
        align-items: flex-start;
    }

    .error-alert-icon {
        color: #ef4444;
        font-size: 15px;
        flex-shrink: 0;
        margin-top: 1px;
    }

    .error-alert-title {
        font-size: 12px;
        font-weight: 600;
        color: #b91c1c;
        margin: 0 0 2px 0;
    }

    .error-list {
        margin: 0;
        padding-left: 14px;
        font-size: 12px;
        color: #dc2626;
    }

    .error-list li {
        margin-bottom: 1px;
    }

    /* Member Search */
    .member-search-row {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 12px;
    }

    .member-search-wrap {
        flex: 1;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 10px 14px;
        gap: 8px;
        background: #FFFFFF;
        border: 1px solid #D4D4D4;
        box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
        border-radius: 8px;
        transition: border-color 0.15s, box-shadow 0.15s;
        height: 44px;
    }

    .member-search-wrap:focus-within {
        border-color: var(--primary-color, #F27178);
        box-shadow: 0 0 0 3px rgba(242, 113, 120, 0.12);
    }

    .search-icon {
        color: #737373;
        font-size: 14px;
        flex-shrink: 0;
    }

    .member-search-input {
        flex: 1;
        border: none;
        outline: none;
        padding: 0;
        font-family: 'Inter', sans-serif;
        font-weight: 400;
        font-size: 14px;
        color: #404040;
        background: transparent;
    }

    .member-search-input::placeholder {
        color: #737373;
    }

    .search-clear-btn {
        background: none;
        border: none;
        color: #9ca3af;
        cursor: pointer;
        font-size: 16px;
        line-height: 1;
        padding: 0;
        flex-shrink: 0;
    }

    .search-clear-btn:hover {
        color: #ef4444;
    }

    /* Scan button: bg primary, border primary, radius 8px, 52x44 */
    .btn-scan {
        width: 52px;
        height: 44px;
        flex-shrink: 0;
        background: var(--primary-color, #F27178);
        border: 1px solid var(--primary-color, #F27178);
        box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
        border-radius: 8px;
        color: white;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        transition: filter 0.15s;
    }

    .btn-scan:hover {
        filter: brightness(0.9);
    }

    .scan-error-msg {
        margin-top: 10px;
        padding: 8px 12px;
        background: #fff5f5;
        border: 1px solid #fecaca;
        border-radius: 6px;
        color: #dc2626;
        font-size: 13px;
        text-align: center;
    }

    /* Member List*/
    .member-list-scroll {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 12px;
        overflow-y: auto;
        max-height: 400px;
    }

    .member-list-scroll::-webkit-scrollbar {
        width: 4px;
    }

    .member-list-scroll::-webkit-scrollbar-track {
        background: transparent;
    }

    .member-list-scroll::-webkit-scrollbar-thumb {
        background: #D4D4D4;
        border-radius: 4px;
    }

    .member-list-empty {
        text-align: center;
        color: #737373;
        font-size: 14px;
        padding: 24px 0;
    }

    .member-card {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        padding: 16px;
        gap: 4px;
        background: #FFFFFF;
        border: 1px solid #E5E5E5;
        border-radius: 12px;
        cursor: pointer;
        transition: border-color 0.15s;
        flex-shrink: 0;
        margin: 0 !important;
    }

    .member-card:hover {
        border-color: var(--primary-color, #F27178);
    }

    .member-card.selected {
        border-color: var(--primary-color, #F27178);
    }

    .member-card-content {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        gap: 12px;
        flex: 1;
        min-width: 0;
    }

    .member-avatar {
        width: 42px;
        height: 42px;
        border-radius: 50%;
        overflow: hidden;
        flex-shrink: 0;
        background: var(--secondary-color, #FEE9E9);
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .avatar-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .avatar-initials {
        font-size: 13px;
        font-weight: 700;
        color: var(--primary-color, #F27178);
    }

    /* Content inside: flex col, gap 8px */
    .member-info {
        flex: 1;
        min-width: 0;
        display: flex;
        flex-direction: column;
        gap: 2px;
    }

    /* Text spec: Inter 700 14px #404040 */
    .member-name {
        font-family: 'Inter', sans-serif;
        font-weight: 700;
        font-size: 14px;
        line-height: 20px;
        color: #404040;
        margin: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    /* Supporting text: Inter 400 14px #525252 */
    .member-email {
        font-family: 'Inter', sans-serif;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #525252;
        margin: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    /* Member code: primary color */
    .member-code {
        font-family: 'Inter', sans-serif;
        font-weight: 700;
        font-size: 13px;
        color: var(--primary-color, #F27178);
        margin: 0;
    }

    /* Checkbox: _Checkbox base spec */
    .member-check-wrap {
        width: 20px;
        height: 20px;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    /* active: 20x20, bg primary, border primary, radius 10px */
    .member-check {
        width: 20px;
        height: 20px;
        background: var(--primary-color, #F27178);
        border: 1px solid var(--primary-color, #F27178);
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 11px;
    }

    /* inactive: 16x16, bg #FFF, border #D4D4D4, radius 8px */
    .member-radio {
        width: 16px;
        height: 16px;
        background: #FFFFFF;
        border: 1px solid #D4D4D4;
        border-radius: 8px;
    }

    /* Right Panel Form Sections */
    .form-section {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .type-cards {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 24px;
    }

    .type-card {
        flex: 1;
        min-height: 100px;
        border-radius: 12px;
        padding: 16px;
        cursor: pointer;
        transition: border-color 0.15s;
        background: #FFFFFF;
        border: 1px solid #E5E5E5;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
        position: relative;
    }

    .type-card:hover {
        border-color: var(--primary-color, #F27178);
    }

    .type-card.active {
        border-color: var(--primary-color, #F27178);
    }

    .type-card-check {
        position: absolute;
        top: 12px;
        right: 12px;
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .type-card-check-filled {
        width: 20px;
        height: 20px;
        background: var(--primary-color, #F27178);
        border: 1px solid var(--primary-color, #F27178);
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 11px;
    }

    /* inactive: 16x16 bg #FFF border #D4D4D4 radius 8px */
    .type-card-check-empty {
        width: 16px;
        height: 16px;
        background: #FFFFFF;
        border: 1px solid #D4D4D4;
        border-radius: 8px;
    }

    .type-card-icon {
        width: 32px;
        height: 32px;
        object-fit: contain;
    }

    /* Text spec: Inter 700 14px #404040 */
    .type-card-label {
        font-family: 'Inter', sans-serif;
        font-weight: 700;
        font-size: 14px;
        line-height: 20px;
        color: #404040;
    }

    .type-card.active .type-card-label {
        color: var(--primary-color, #F27178);
    }

    /* =============================================
   Calculation Method  (Frame 9 spec)
============================================= */
    /* Frame 9: flex row, gap 12px, h 52px */
    .radio-group {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 12px;
    }

    /* Checkbox group item: padding 16px, gap 12px, radius 12px, h 52px */
    .radio-option {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 16px;
        gap: 12px;
        flex: 1;
        height: 52px;
        background: #FFFFFF;
        border: 1px solid #E5E5E5;
        border-radius: 12px;
        cursor: pointer;
        transition: border-color 0.15s;
        user-select: none;
    }

    .radio-option input[type="radio"] {
        display: none;
    }

    .radio-option.active {
        border-color: var(--primary-color, #F27178);
    }

    /* inactive radio: 16x16 #FFF border #D4D4D4 radius 8px */
    .radio-check {
        width: 16px;
        height: 16px;
        background: #FFFFFF;
        border: 1px solid #D4D4D4;
        border-radius: 8px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        transition: all 0.15s;
    }

    /* active radio: 20x20 bg primary radius 10px */
    .radio-option.active .radio-check {
        width: 20px;
        height: 20px;
        background: var(--primary-color, #F27178);
        border-color: var(--primary-color, #F27178);
        border-radius: 10px;
    }

    .radio-check::after {
        content: '';
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: white;
        opacity: 0;
        transition: opacity 0.15s;
    }

    .radio-option.active .radio-check::after {
        opacity: 1;
    }

    /* Text: Inter 700 14px #404040 */
    .radio-label {
        font-family: 'Inter', sans-serif;
        font-weight: 700;
        font-size: 14px;
        line-height: 20px;
        color: #404040;
    }

    .radio-option.active .radio-label {
        color: var(--primary-color, #F27178);
    }

    /* =============================================
   Textarea  (border #D4D4D4, shadow xs, radius 8px)
============================================= */
    .form-textarea {
        width: 100%;
        background: #FFFFFF;
        border: 1px solid #D4D4D4;
        box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
        border-radius: 8px;
        padding: 12px 14px;
        font-family: 'Inter', sans-serif;
        font-size: 14px;
        line-height: 24px;
        color: #404040;
        resize: none;
        outline: none;
        transition: border-color 0.15s, box-shadow 0.15s;
    }

    .form-textarea::placeholder {
        color: #737373;
    }

    .form-textarea:focus {
        border-color: var(--primary-color, #F27178);
        box-shadow: 0 0 0 3px rgba(242, 113, 120, 0.12);
    }

    /* Footer Actions  — outside two-col container per Figma */
    .form-footer {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: 12px;
        padding: 16px 24px;
        margin-bottom: -20px;
        margin-left: -24px;
        margin-right: -24px;
        position: sticky;
        bottom: -20px;
        background: #ffffff;
        z-index: 10;
        border-top: 1px solid #E5E5E5;
    }

    .footer-actions {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 12px;
        margin-left: auto;
    }

    .error-alert-footer {
        display: flex;
        gap: 10px;
        background: #fff5f5;
        border: 1px solid #fecaca;
        border-radius: 8px;
        padding: 8px 12px;
        align-items: flex-start;
        margin-right: auto;
    }


    /* Cancel: bg #FFF, border #D4D4D4, shadow xs, radius 8px, w 90px h 44px */
    .btn-cancel {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px 18px;
        height: 44px;
        min-width: 90px;
        background: #FFFFFF;
        border: 1px solid #D4D4D4;
        box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
        border-radius: 8px;
        font-family: 'Inter', sans-serif;
        font-weight: 600;
        font-size: 16px;
        color: #404040;
        cursor: pointer;
        transition: background 0.15s;
    }

    .btn-cancel:hover {
        background: #f9fafb;
    }

    /* Confirm: bg primary, border primary, shadow xs, radius 8px, w 99px h 44px */
    .btn-confirm {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 10px 18px;
        height: 44px;
        min-width: 99px;
        background: var(--primary-color, #F27178);
        border: 1px solid var(--primary-color, #F27178);
        box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
        border-radius: 8px;
        font-family: 'Inter', sans-serif;
        font-weight: 600;
        font-size: 16px;
        color: #FFFFFF;
        cursor: pointer;
        transition: filter 0.15s;
    }

    .btn-confirm:hover:not(:disabled) {
        filter: brightness(0.9);
    }

    .btn-confirm:disabled {
        opacity: 0.65;
        cursor: not-allowed;
    }

    /* Scanner modal (inline) */
    .modal.hidden {
        display: none !important;
    }

    /* Legacy */
    input[type="radio"] {
        accent-color: var(--primary-color, #F27178);
    }

    .form-control:focus {
        border-color: var(--primary-color, #F27178);
        box-shadow: 0 0 0 0.2rem rgba(242, 113, 120, 0.2);
    }

    /* Responsive — Tablet (max 900px) */
    @media (max-width: 900px) {
        .inject-modal-wide {
            max-width: 98vw !important;
            width: 98vw !important;
            max-height: 92vh !important;
        }

        .two-col-layout {
            flex-direction: column;
            min-height: unset;
            border-radius: 12px;
        }

        .left-panel {
            width: 100%;
            border-radius: 12px 12px 0 0;
            max-height: 340px;
            overflow-y: auto;
            flex-shrink: 0;
        }

        .right-panel {
            border-radius: 0 0 12px 12px;
            max-height: unset;
            overflow-y: visible;
        }

        .type-cards {
            gap: 12px;
        }
    }

    /* Responsive — Mobile (max 576px) */
    @media (max-width: 576px) {
        .inject-modal-wide {
            max-width: 100vw !important;
            width: 100vw !important;
            max-height: 95vh !important;
            margin: 0 !important;
        }

        .inject-modal-wide .modal-body {
            padding: 14px 14px;
        }

        .left-panel {
            padding: 16px;
            max-height: 280px;
        }

        .right-panel {
            padding: 16px;
            gap: 16px;
        }

        .member-list-scroll {
            max-height: 220px;
        }

        .type-cards {
            flex-direction: column;
            gap: 10px;
        }

        .type-card {
            min-height: 60px;
            padding: 12px 16px;
            flex-direction: row;
            align-items: center;
            gap: 12px;
        }

        .type-card-check {
            position: static;
            margin-left: auto;
        }

        .type-card-icon {
            width: 24px;
            height: 24px;
        }

        .radio-group {
            flex-direction: column;
            gap: 10px;
        }

        .radio-option {
            width: 100%;
            height: 44px;
            padding: 10px 14px;
        }

        .form-footer {
            padding-top: 12px;
        }

        .btn-cancel,
        .btn-confirm {
            font-size: 14px;
            padding: 10px 14px;
        }
    }

    /* Custom Input Card (Figma Style) */
    .custom-input-card {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 12px 16px;
        gap: 12px;
        background: #FFFFFF;
        border: 1px solid #E5E5E5;
        border-radius: 12px;
        height: 52px;
        transition: border-color 0.15s;
    }

    .custom-input-card:focus-within {
        border-color: var(--primary-color, #7e3af2);
    }

    .custom-input-card.is-disabled {
        background: #F9F9F9;
        cursor: not-allowed;
    }

    .custom-input-card .input-icon-wrap {
        color: var(--primary-color, #7e3af2);
        font-size: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 24px;
    }

    .custom-input-card .custom-input-field {
        flex: 1;
        border: none;
        outline: none;
        background: transparent;
        font-family: 'Inter', sans-serif;
        font-size: 16px;
        font-weight: 600;
        color: #1f2937;
        width: 100%;
    }

    .custom-input-card .custom-input-field:disabled {
        color: #9CA3AF;
    }

    .custom-input-card .custom-input-field::placeholder {
        color: #D1D5DB;
        font-weight: 400;
    }
</style>